import { Component, inject } from "@angular/core";
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-roster-run-dialog",
  templateUrl: "./roster-run-dialog.component.html",
  styleUrls: ["./roster-run-dialog.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    DialogHeaderComponent
  ]
})
export class RosterRunDialogComponent {
  dialogRef = inject<MatDialogRef<RosterRunDialogComponent>>(MatDialogRef);

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close({ confirmed: true });
  }
}
